import React from "react";

const SigninSheetContext = React.createContext();

export const SigninSheetProvider = SigninSheetContext.Provider;
export const SigninSheetConsumer = SigninSheetContext.Consumer;

export default SigninSheetContext;
